import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { WHATSAPP_LINK } from "../mock";

// Inline WhatsApp glyph (brand mark) — kept as a clean SVG icon
const WhatsAppIcon = ({ size = 30, color = "#fff" }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M16.003 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.6 4.46 1.73 6.4L3.2 28.8l6.57-1.72a12.74 12.74 0 0 0 6.23 1.6h.01c7.06 0 12.8-5.74 12.8-12.8s-5.74-12.68-12.8-12.68Zm0 23.03h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-4 1.05 1.07-3.9-.25-.4a10.57 10.57 0 0 1-1.62-5.63c0-5.86 4.77-10.63 10.64-10.63 2.84 0 5.5 1.11 7.51 3.12a10.55 10.55 0 0 1 3.11 7.52c0 5.86-4.77 10.63-10.63 10.63Zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.72.16-.21.32-.82 1.04-1 1.25-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.58-.95-.85-1.59-1.9-1.78-2.22-.19-.32-.02-.5.14-.66.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.72-1.74-.99-2.38-.26-.62-.53-.54-.72-.55l-.61-.01c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.66 0 1.57 1.14 3.08 1.3 3.29.16.21 2.25 3.43 5.44 4.81.76.33 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.89-.77 2.16-1.52.27-.75.27-1.39.19-1.52-.08-.13-.29-.21-.61-.37Z"/>
  </svg>
);

const WhatsAppWidget = () => {
  const [showBubble, setShowBubble] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setMounted(true), 600);
    const t2 = setTimeout(() => setShowBubble(true), 1600);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  const open = () => window.open(WHATSAPP_LINK, "_blank", "noopener");

  return (
    <div className="fixed z-[60] right-5 bottom-5 md:right-8 md:bottom-8 flex flex-col items-end gap-3">
      {showBubble && (
        <div
          className="wa-pop relative max-w-[248px] rounded-2xl px-5 py-4 shadow-xl"
          style={{ background: "var(--cream-3)", border: "1px solid rgba(89,26,32,0.12)" }}
        >
          <button
            onClick={() => setShowBubble(false)}
            className="absolute -top-2 -right-2 w-6 h-6 rounded-full flex items-center justify-center"
            style={{ background: "var(--wine)", color: "var(--cream)" }}
            aria-label="Close"
          >
            <X size={13} />
          </button>
          <p className="font-display text-lg leading-snug" style={{ color: "var(--wine)" }}>
            Namaste, we are here.
          </p>
          <p className="font-body text-[0.86rem] mt-1 leading-relaxed" style={{ color: "var(--muted)" }}>
            Styling help, sizing, or a quick hello — chat with us on WhatsApp.
          </p>
          <button
            onClick={open}
            className="mt-3 w-full rounded-full py-2.5 font-mono2 flex items-center justify-center gap-2"
            style={{ background: "#25D366", color: "#fff", fontSize: "0.64rem", letterSpacing: "0.12em" }}
          >
            <WhatsAppIcon size={15} /> START CHAT
          </button>
        </div>
      )}

      {mounted && (
        <button
          onClick={open}
          className="wa-enter wa-pulse w-16 h-16 rounded-full flex items-center justify-center transition-transform duration-300 hover:scale-110"
          style={{ background: "#25D366" }}
          aria-label="Chat on WhatsApp"
        >
          <WhatsAppIcon size={32} />
        </button>
      )}
    </div>
  );
};

export { WhatsAppIcon };
export default WhatsAppWidget;
